import type { ReactNode } from "react";
import styles from "./Screen.module.css";

/**
 * `fixed`: locks the screen to the viewport height with no page-level
 * scroll (used by QuizScreen — the demo's one-screen requirement). Default
 * behavior (no `fixed`) is unchanged: content grows naturally and the page
 * scrolls if it needs to.
 */
export function Screen({ children, fixed }: { children: ReactNode; fixed?: boolean }) {
  const classes = [styles.screen, fixed ? styles.fixed : ""].filter(Boolean).join(" ");
  return <div className={classes}>{children}</div>;
}
